import React from 'react';
import { Provider } from 'react-redux';
import store from '../store';
import AppRouter from '../routes/AppRouter';
import ErrorBoundary from './ErrorBoundary';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

//providers
import FbProvider from './FbProvider';
import ThemeProvider from '../theme/ThemeProvider';

const App = () => (
  <Provider store={store}>
    <ErrorBoundary>
      <ThemeProvider>
        <FbProvider>
          <AppRouter />
        </FbProvider>
      </ThemeProvider>
    </ErrorBoundary>
    <ToastContainer />
  </Provider>);

export default App;
